export const languageReducer = (state = '', action) => {
    switch (action.type) {
        case 'INIT_LANGUAGE':
            return action.payload;
        default:
            return state;
    }
};
